import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';


// Passed through a variable (not a fresh literal) so TS allows the react-admin
// `sidebar` extension key on MUI's ThemeOptions.
const themeOptions = {
  // react-admin reads theme.sidebar.width (default 240) — widened so the
  // Sessions badge pill isn't clipped at the drawer edge.
  sidebar: {
    width: 300,
  },
  palette: {
    primary: {
      main: '#2eb4b6'
    },
    secondary: {
      main: '#e6831c',
      contrastText: '#fff'
    },
    error: red,
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  overrides: {
    MuiButton: { // override the styles of all instances of this component
      root: { // Name of the rule
        color: 'white', // Some CSS
      },
    },
  },
};

const theme = createMuiTheme(themeOptions);

export default theme;